<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("common.student") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <yv-index
        :path="path"
        :formSearch="formSearch"
        :columns="columns"
        :inlineSearchAction="true"
        :paginationCfg="{
          perPage: 20,
          hidePerPageOptions: true
        }"
        :formatTableData="formatTableData"
        :sortData="{}"
        :tableDesc="tableDesc"
        :hideLoading="true"
        :hideAction="true"
        :hideBulkAction="true"
        ref="topGPATable"
      >
        <template #search-actions="{ actions }">
          <md-button
            native-type="submit"
            @click="actions.search"
            class="md-info md-round"
            ref="searchBtn"
            v-show="false"
          >
          </md-button>
        </template>
      </yv-index>
    </md-card-content>
  </md-card>
</template>

<script>
import YvIndex from "@/components/Base/YvIndex.vue";
import { STUDENT_TABLE as stdTableUtils } from "@/pages/Report/utils";

export default {
  components: { YvIndex },
  inject: ["reportParams", "basePath"],
  data() {
    const defaultOrderType = "Top";
    const defaultRank = 10;

    return {
      orderType: "Top",
      formSearch: [
        {
          label: this.$t(
            "score_report.overview.student_table_filtering_by_order"
          ),
          name: "order_type",
          value: defaultOrderType,
          type: "select",
          options: [
            {
              id: "Top",
              name: "Top"
            },
            {
              id: "Bottom",
              name: "Bottom"
            }
          ],
          onSelected: selected => {
            this.$nextTick(() => {
              this.fetchTopGPAs();
            });
          }
        },
        {
          label: this.$t(
            "score_report.overview.student_table_filtering_by_range"
          ),
          name: "rank",
          value: defaultRank,
          type: "select",
          options: [
            {
              id: 5,
              name: "5"
            },
            {
              id: 10,
              name: "10"
            },
            {
              id: 20,
              name: "20"
            }
          ],
          onSelected: selected => {
            this.fetchTopGPAs();
          }
        }
      ],
      columns: {
        student_info: this.$t("common.student"),
        student_code: this.$t("common.student_code"),
        rank: this.$t("score_report.overview.student_table_col_rank"),
        gpa: this.$t("score_report.overview.gpa"),
        status: this.$t("score_report.overview.student_table_col_status")
      }
    };
  },
  computed: {
    path() {
      const termId = this.reportParams.searchingTerm?.id;
      const gradeId = this.reportParams.searchingGrade?.id;

      const topGPAPath = `${this.basePath}/gpa/top-gpa-students`;

      return `${topGPAPath}?term_id=${termId}&grade_id=${gradeId}`;
    },
    tableDesc() {
      const termName = this.reportParams.searchingTerm?.name;
      const orderType = this.formSearch[0].value;
      const rank = this.formSearch[1].value;

      return `${orderType} ${rank} GPA scores for: ${termName}`;
    }
  },
  methods: {
    async fetchTopGPAs(shouldShowLoading = true) {
      return this.$refs.topGPATable.getTableData(shouldShowLoading);
    },
    formatTableData(topGPAs) {
      return topGPAs.map(student => ({
        student_info: this.generateInfoColHTML(student),
        student_code: student.student_code,
        rank: student.rank,
        gpa: student.gpa,
        status: stdTableUtils.generateStatusColHTML(student.study_status)
      }));
    },
    generateInfoColHTML(student) {
      const avatarURL = student.avatar || "/img/avt_placeholder.jpg";
      return `<div class="flex items-center">
        <img src="${avatarURL}" class="object-cover rounded-full w-[42px] h-[42px]">
        <p class="font-normal ml-2">${student.full_name}</p>
      </div>`;
    }
  }
};
</script>

<style lang="scss">
.isis-table {
  padding-left: 10px;
}
</style>
